<template>
<div class="leak-source-data-cell">
  <div class='leak-source-data-cell__content'>{{ getSource }}</div>
  <div v-if='hasSources' class='leak-source-data-cell__help' @click='onHelpClick'>
      <v-icon class="material-icons-round">help</v-icon>
  </div>
</div>
</template>

<script>
export default {
  name: 'NameDataTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getSource() {
      const source = [];
      if (this.hasSources) {
        this.item.leakSources.forEach(leakSource => {
          source.push(leakSource);
        });
      }
      return source.join(', ');
    },
    hasSources() {
      return this.item.leakSources?.length > 0;
    },
  },
  methods: {
    onHelpClick() {
      this.$emit('leakSourceHelp', this.item.sourceData);
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/assets/styles/design-system';
.leak-source-data-cell{
  display: flex;
  align-items: center;
  margin-right: rem(40);
  &__content {
    text-transform: capitalize;
    color: var(--text-primary);
    font-size: rem(14);
    line-height: rem(18);
    font-family: $font-family-regular;
    max-height: rem(53);
    width: rem(400);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
  }
  &__help{
    .v-icon{
      font-size: rem(18);
      color: var(--text-secondary);
      margin-left: rem(10);
    }
    :hover {
      cursor: pointer;
    }
  }
}

</style>
